import React from 'react'
import { IconButton, SvgIconProps } from '@mui/material'
import { UserAvatar } from '$common/avatar'
import { nothing } from '$func/utils'
import { AvatarSize } from '$common/avatar/avatar-base/types'
import { UserListItemBase } from './user-list-item-base'

interface Props {
  userId: string | undefined
  role?: string
  primaryText?: JSX.Element
  secondaryText?: string | JSX.Element
  SecondaryActionIcon?: React.ComponentType<SvgIconProps>
  hasDivider?: boolean
  isTransparent?: boolean
  onClick?: () => unknown
  onContextMenu?: (e: Event) => unknown
  onSecondaryActionIconClick?: () => unknown
  selected?: boolean
  fullOpacity?: boolean
  disableAvatarClick?: boolean
}

export function UserListItem({
  userId,
  role = '',
  primaryText,
  secondaryText,
  SecondaryActionIcon,
  hasDivider = true,
  isTransparent = false,
  onClick = nothing,
  onContextMenu = nothing,
  selected = false,
  onSecondaryActionIconClick = nothing,
  fullOpacity = false,
  disableAvatarClick,
}: Props) {
  return (
    <UserListItemBase
      userId={userId}
      role={role}
      primaryText={primaryText}
      secondaryText={secondaryText}
      avatarComponent={
        <UserAvatar
          userId={userId}
          checked={selected}
          size={AvatarSize.MD}
          withStory
          disableClick={disableAvatarClick}
        />
      }
      secondaryActionComponent={
        SecondaryActionIcon ? (
          <IconButton
            sx={{ borderRadius: 0, width: '56px', height: '56px' }}
            size="large"
            onClick={e => {
              e.stopPropagation()
              onSecondaryActionIconClick()
            }}
          >
            <SecondaryActionIcon fill="#818181" />
          </IconButton>
        ) : (
          undefined
        )
      }
      hasDivider={hasDivider}
      isTransparent={isTransparent}
      onClick={onClick}
      onContextMenu={onContextMenu}
      fullOpacity={fullOpacity}
    />
  )
}
